/**
 * Mask ID / passport for display: only last 4 characters visible.
 * Full value is never shown except while the field is focused (typing).
 */
export function maskSensitiveId(value: string): string {
  const v = String(value || '').replace(/\s/g, '');
  if (!v) return '';
  if (v.length <= 4) return '•'.repeat(v.length);
  return `${'•'.repeat(v.length - 4)}${v.slice(-4)}`;
}

export function normalizeIdInput(value: string): string {
  return String(value || '').replace(/\s/g, '');
}
